import {createSlice} from '@reduxjs/toolkit';


export const ApplicantReducer = createSlice({
    name:'applicant',
    initialState:{allApplicant: [], workExprience: {}, exams_applicant: []},
    reducers:{
        setAllApplicant: (state,action)=>{
            return {
                ...state, allApplicant: action.payload
            }
        },
        addWorkExperience: (state, action)=>{
            const newExperience = action.payload;
            return {
                ...state, workExprience: {
                    ...newExperience,
                    ...state.workExprience,
                }
            }
        },
        setExamApplicant:(state, action) => {
            return {
                ...state,exams_applicant: action.payload,
            }
        }
    }


})

export const {setAllApplicant,addWorkExperience,setExamApplicant} = ApplicantReducer.actions;
export default ApplicantReducer.reducer;